import { ThirdPartyCookieError } from './cookies';

type IsThirdPartyCookieError = (error: unknown) => boolean;
export const isThirdPartyCookieError: IsThirdPartyCookieError = (error) => error instanceof ThirdPartyCookieError;
